import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { MenuProps } from 'antd';
import { Link } from 'react-router-dom';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';
import { useIsAdmin } from 'src/lib/customHooks/useIsAdmin';
import { useStore } from '../../store/reducers.js';
import { toastSuccess } from '../utils/Utils.js';

export const useAdminMenuItems = (): NonNullable<MenuProps['items']> => {
  const isAdmin = useIsAdmin();
  const currentUser = useCurrentUser();
  const { toggleFakeUser } = useStore((s) => s.users.actions);

  if (!isAdmin || currentUser == null) return [];

  const handleToggle = async () => {
    const wasFakeUser = currentUser.fakeUser;

    await toggleFakeUser();
    toastSuccess({
      title: 'Admin Feature',
      message: wasFakeUser ? 'You switched back to admin mode!' : 'You switched to fake user mode!',
    });
  };

  return [
    {
      key: '/admin/users',
      label: (
        <Link to="/admin/users" id={TestSelectors.admin.nav.sections.users.toString()}>
          Users
        </Link>
      ),
    },
    {
      key: '/admin/events/manage',
      label: (
        <Link to="/admin/events/manage" id={TestSelectors.admin.nav.sections.events.toString()}>
          Events
        </Link>
      ),
    },
    {
      key: '/admin/billing/report',
      label: (
        <Link to="/admin/billing/report" id={TestSelectors.admin.nav.sections.billing.toString()}>
          Billing Report
        </Link>
      ),
    },
    {
      key: '/admin/user-feedback',
      label: (
        <Link
          to="/admin/user-feedback"
          id={TestSelectors.admin.nav.sections.userFeedback.toString()}
        >
          User Feedback
        </Link>
      ),
    },
    {
      key: '/admin/user-credits',
      label: (
        <Link to="/admin/user-credits" id={TestSelectors.admin.nav.sections.userCredits.toString()}>
          User Credits
        </Link>
      ),
    },
    {
      key: '/admin/starter-tags',
      label: (
        <Link to="/admin/starter-tags" id={TestSelectors.admin.nav.sections.starterTags.toString()}>
          Starter Tags
        </Link>
      ),
    },
    {
      key: '/admin/predictive/emulation',
      label: (
        <Link
          to="/admin/predictive/emulation"
          id={TestSelectors.admin.nav.sections.predictiveEmulation.toString()}
        >
          Predictive Emulation
        </Link>
      ),
    },
    { type: 'divider' },
    {
      key: 'fake-user',
      label: currentUser.fakeUser ? 'Switch back to admin mode' : 'Switch to fake user mode',
      onClick: handleToggle,
    },
  ];
};
